// extracted by mini-css-extract-plugin
export default {"Container":"TableItem_Container__KBtKU"};